import { useContext } from "react";
import {
  AppSnackbarContext,
  AppSnackbarContextType,
} from "../components/AppSnackbarProvider";

/**
 * Hook to access the app-wide snackbar notification system.
 * Must be used within an AppSnackbarProvider.
 *
 * @example
 * const { showSnackbar } = useAppSnackbar();
 * showSnackbar("Operation successful!", "success");
 * showSnackbar("Something went wrong", "error");
 */
export const useAppSnackbar = (): AppSnackbarContextType => {
  const context = useContext(AppSnackbarContext);

  if (!context) {
    throw new Error(
      "useAppSnackbar must be used within an AppSnackbarProvider"
    );
  }

  return context;
};

export default useAppSnackbar;
